module.exports = __webpack_public_path__ + "static/media/roi-return.92bd39af.png";